var map = {
	"./account-active.svg": 5841,
	"./account-inactive.svg": 2196,
	"./home-active.svg": 2243,
	"./home-inactive.svg": 4378,
	"./news-active.svg": 1731,
	"./news-inactive.svg": 4298,
	"./shop-active.svg": 176,
	"./shop-inactive.svg": 1881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4123;